// tslint:disable

import { EntityType } from '../../../entities/src/model';

const gatewayUrl = 'https://gateway.services.moostaging.com/';
const newGatewayUrl = 'https://gw.services.moostaging.com/';
const origin = typeof location !== 'undefined' ? location.origin : 'asd';

const oldApis = {
	api: 'https://api.moostaging.com/v3/',
	support_api: 'https://api.moostaging.com/support/',
};

const clients = {
	get: (apiKey: string) => `${oldApis.api}clients.json?format=json&apikey=${apiKey}&mode=View`,
};

const auth = {
	base: 'https://auth.sitecoresendstaging.io',
	refresh: '/tokens/refresh',
	authenticate: '/send/authenticate',
	impersonation: '/impersonation/subaccount',
	login: (org: string, tenantId: string) => `/send?organization=${org}&tenantId=${tenantId}`,
	appSwitcherEnv: 'staging',
	portal: 'https://portal-staging.sitecore-staging.cloud/',
};

const user_management_service = {
	base_url: `${gatewayUrl}user`,
	auth_url: `https://authentication-staging.m-operations.com/api/user/authenticate.json?domain={domain}&UsernameOrEmail={username}&Password={password}&format=json`,
	forgot_password_url: `https://authentication-staging.m-operations.com/api/user/password/forgot`,
	change_password_url: `https://authentication-staging.m-operations.com/api/user/password/reset`,
	user_data_url: `https://authentication-staging.m-operations.com/api/site/name/{domain}`,
	plugin_secret: `${gatewayUrl}user/plugins/secret`,
	user_details_url: `${gatewayUrl}user/details`,
	post_generate_token: `${gatewayUrl}user/service-tokens`,
	log_out: `${gatewayUrl}user/logout`,
	delete_generate_token: (resourceId: string) => `${gatewayUrl}user/service-tokens?resourceId=${resourceId}`,
	user_site: (userid: string) => `${gatewayUrl}site/user-id/${userid}`,
	get_domains: (type: string, includeNativeParents: string) =>
		`${gatewayUrl}user/domains/filter?WhereType=${type}&IncludeParentNativeDomains=${includeNativeParents}`,
	delete_domain: (domainId: string) => `${gatewayUrl}user/domains/${domainId}`,
	post_domain: (nativeDomainId: string) => `${gatewayUrl}user/domains?CopySettingsFrom=${nativeDomainId}`,
	put_domain: (domainId: string) => `${gatewayUrl}user/domains/${domainId}`,
	validate_domain: (domainId: string) => `${gatewayUrl}user/domains/${domainId}/validate`,
	domain_settings: (domainId: string) => `${gatewayUrl}user/domains/${domainId}/settings`,
	settings_by_domain: (domain: string) => `${gatewayUrl}user/domains/by-custom-domain?Type=PlatformDomain&CustomDomain=${domain}`,
	get_sub_accounts: `${gatewayUrl}user/subaccounts`,
	get_sub_account: (id: string) => `${gatewayUrl}user/subaccount/${id}`,
	create_sub_accounts: `${gatewayUrl}user/subaccount`,
	logout: `${gatewayUrl}user/logout`,
	check_login: `${gatewayUrl}user/logged-in`,
	user_hash: `${gatewayUrl}crypto/user-id`,
};

const campaign_management_service = {
	base_url: `${gatewayUrl}campaigns`,
	get_filter_campaigns: `${gatewayUrl}campaigns/filtered/with-extras`,
	get_refresh_campaigns: `${gatewayUrl}campaigns/with-extras/refresh`,
	get_campaign: (campaignId: string, localtime: boolean = true, noGateway?: boolean) =>
		`${noGateway ? '/' : gatewayUrl}campaigns/${campaignId}${localtime ? '?ConvertScheduledTimeToLocal=true' : ''}`,
	post_campaign: `${gatewayUrl}campaigns?ConvertScheduledTimeToLocal=true`,
	update_campaign: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}?ConvertScheduledTimeToLocal=true`,
	clone_campaign: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/clone?IncludeMailingListInfo=true`,
	delete_campaign: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}`,
	get_campaign_settings: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/settings/all`,
	post_campaign_setting: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/settings`,
	campaign_loadcontent: `${gatewayUrl}campaigns/loadcontent`,
	get_total_recipients_count: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/recipients/count`,
	send_campaign: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/send`,
	unschedule_campaign: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/unschedule`,
	get_all_campaign_labels: () => `${gatewayUrl}campaigns/labels/filtered`,
	delete_selected_campaigns: (CampaignIds: string) => `${gatewayUrl}campaigns/many?${CampaignIds}`,
	add_campaign_label: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/labels`,
	delete_campaign_label: (campaignId: string, name: string) => `${gatewayUrl}campaigns/${campaignId}/labels?Name=${name}`,
	get_show_campaign: (campaignId: string, ab: 'a' | 'b' | '' = '') =>
		`https://app.moostaging.com/show_campaign/${campaignId}/00000000-0000-0000-0000-000000000000/${ab}`,
	send_to_nonopeners: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/nonopeners/user-created`,
	cancel_campaign: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/cancel`,
	share_url: 'https://app.moostaging.com',
	setTags: (campaignId: string) => `${gatewayUrl}campaigns/${campaignId}/labels`,
	setManyTags: `${gatewayUrl}campaigns/many/labels`,
	get_scheduling_recommendation: (campaignId: string, granularity = 'byHour') => `${gatewayUrl}campaigns/${campaignId}/suggest-scheduling?Granularity=${granularity}`,
};

const digests_service = {
	base_url: `${gatewayUrl}campaigns`,
	get_filter_digests: () => `${gatewayUrl}campaigns/digests/filtered/with-extras`,
	get_digest: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}?ConvertScheduledTimeToLocal=true`,
	post_digest: `${gatewayUrl}campaigns/digests?ConvertScheduledTimeToLocal=true`,
	update_digest: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}?ConvertScheduledTimeToLocal=true`,
	delete_digest: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}`,
	clone_digest: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}/clone`,
	start_campaign: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}/start`,
	stop_campaign: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}/stop`,
	plugins: {
		Rss: 'AF7D8A09-C5A8-448E-8D9B-B449B4863516',
		Imported: 'EFBD340F-D090-44B8-B7D4-6A875D16B6CA',
	},
	get_all_digest_campaign_labels: () => `${gatewayUrl}campaigns/digests/all/labels`,
	delete_selected_campaigns: (DigestIds: string) => `${gatewayUrl}campaigns/digests/many?${DigestIds}`,
	add_campaign_label: (digestId: string) => `${gatewayUrl}campaigns/digests/${digestId}/labels`,
	delete_campaign_label: (campaignId: string, name: string) => `${gatewayUrl}campaigns/digests/${campaignId}/labels?Name=${name}`,
	get_children: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}/child-campaigns`,
	validate_rss: (source: string) => `${gatewayUrl}campaigns/digests/rss/validate?source=${source}`,
	setTags: (campaignId: string) => `${gatewayUrl}campaigns/digests/${campaignId}/labels`,
	setManyTags: `${gatewayUrl}campaigns/digests/many/labels`,
};

const billingService = {
	all_plans: `${gatewayUrl}billing/purchasables/all`,
	recurring_plans: `${gatewayUrl}billing/purchasables/all/a39ba389-9155-4817-8f6b-4fa3faa7eb39`,
	credits: `${gatewayUrl}billing/purchasables/all/26868208-3113-4ba5-a87c-283baddab89b`,
	usedCredits: `${gatewayUrl}billing/inventory/consumables/26868208-3113-4ba5-a87c-283baddab89b/totals-by-interval`,
	current_plan: `${gatewayUrl}billing/subscription/status`,
	current_parent_plan: `${gatewayUrl}billing/subscription/status/parent`,
	payment_details: `${gatewayUrl}billing/billing/payment-details`,
	primary_method: (paymentId: string) => `${gatewayUrl}billing/billing/payment-details/${paymentId}/primary`,
	invoice_settings: `${gatewayUrl}billing/billing/billing-details`,
	transact: `${gatewayUrl}billing/transactions`,
	invoices: `${gatewayUrl}billing/invoices`,
	download_invoice: (invoiceId: string) => `${gatewayUrl}billing/invoices/${invoiceId}`,
	braintree_token: `${gatewayUrl}billing/metadata`,
	braintree_renew: (paymentDetailsId: string) => `${gatewayUrl}billing/metadata/renew-nonce?paymentDetailsId=${paymentDetailsId}`,
	// old, very old
	subscriber_count: (apiKey: string) => `${oldApis.api}account/subscribers/count.json?format=json&apikey=${apiKey}&mode=view`,
	preview: (code: string) => `${gatewayUrl}billing/checkout/estimate?PurchasableCode=${code}`,
	checkout: `${gatewayUrl}billing/checkout`,
	retention_precancel: `${gatewayUrl}billing/retention/precancel`,
};

const accountService = {
	base_url: `${gatewayUrl}user`,
	getAccountSettings: `${gatewayUrl}user/settings/categorized`,
	updatePassword: `${gatewayUrl}user/password/update`,
	updateApiKey: `${gatewayUrl}user/apikey`,
	getSender: (senderId: string, noGateway?: boolean) => `${noGateway ? '/' : gatewayUrl}user/senders/sender-id/${senderId}`,
	updateSender: `${gatewayUrl}user/senders`,
	getSenders: `${gatewayUrl}user/senders/details`,
	addNewSender: `${gatewayUrl}user/senders`,
	deleteSender: (senderId: string) => `${gatewayUrl}user/senders?senderId=${senderId}`,
	checkBusinessEmail: `${gatewayUrl}user/senders/check-domain-type`,
	verifyDNSSender: `${gatewayUrl}senderdomains/verify`,
	updateAccountSettings: `${gatewayUrl}user/settings/update`,
	getUserSite: (userId: string) => `${gatewayUrl}site/user-id/${userId}`,
	updateUserSite: `${gatewayUrl}site/details`,
	updateLogo: `${gatewayUrl}blobuploads/new/file?Storage=S3`,
	removeLogo: `${gatewayUrl}site/logo`,
	updateUserSubdomain: `${gatewayUrl}site/subdomain`,
	deleteUserSubdomain: `${gatewayUrl}site/subdomain`,
	verifyUserSubdomain: `${gatewayUrl}site/subdomain/verify`,
	getWebsites: `${gatewayUrl}websites`,
	getWebsitesByStatus: (status: number) => `${gatewayUrl}websites?Status=${status}`,
	createWebsite: `${gatewayUrl}websites`,
	singleWebsite: (websiteId: string | number) => `${gatewayUrl}websites/${websiteId}`,
	get_permissions: (teamMemberId: string) => `${gatewayUrl}user/team-members/${teamMemberId}/permissions`,
	getTeamMember: (teamMemberId: string) => `${gatewayUrl}user/team-members/${teamMemberId}`,
	getTeamMembers: `${gatewayUrl}user/team-members`,
	deleteTeamMember: (teamMemberId: string) => `${gatewayUrl}user/team-members/${teamMemberId}`,
	updateTeamMember: (teamMemberId: string) => `${gatewayUrl}user/team-members/${teamMemberId}`,
	createTeamMember: `${gatewayUrl}user/team-members`,
	getSubAccount: (apiKey: string, id: string) => `https://api.moostaging.com/v3/clients/${id}/details.json?apikey=${apiKey}&mode=View`,
	updateSubAccount: (apiKey: string) => `https://api.moostaging.com/v3/clients/update.json?format=json&apikey=${apiKey}&mode=View`,
	createSubAccount: (apiKey: string) => `https://api.moostaging.com/v3/clients/update.json?format=json&apikey=${apiKey}&mode=View`,
	getMailchimpCampaignData: (apiKey: string, userId: string) =>
		`${gatewayUrl}plugins/mailchimpsynchronizer/selections/campaigns/${userId}/${apiKey}/0/50`,
	getMailchimpListData: (apiKey: string, userId: string) =>
		`${gatewayUrl}plugins/mailchimpsynchronizer/selections/lists/${userId}/${apiKey}/0/50`,
	shouldSync: (userId: string) => `${gatewayUrl}plugins/mailchimpsynchronizer/shouldsync/${userId}`,
	synchronize: `${gatewayUrl}plugins/mailchimpsynchronizer/synchronize`,
	team_member_details: (teamMemberId: string) => `${gatewayUrl}user/team-members/${teamMemberId}`,
	team_member_details_by_owner: `${gatewayUrl}user/team-members/owner`,
};

const members_management_service = {
	base_url: `${gatewayUrl}members`,
	get_mailing_lists_simple: (page: number, pageSize: number) => `${gatewayUrl}members/lists?page=${page}&pageSize=${pageSize}`,
	get_mailing_lists: `${gatewayUrl}members/lists/with-extras?page={page}&pageSize={pageSize}&ExcludeTransactional={ExcludeTransactional}`,
	get_mailing_list: `${gatewayUrl}members/lists/{mailingListId}`,
	search_mailinglists: (Page: number, PageSize: number) =>
		`${gatewayUrl}members/lists/with-extras/search/page/${Page}/pageSize/${PageSize}`,
	filterByMailingListIds: (Page: number, PageSize: number, ExcludeTransactional: boolean) =>
		`${gatewayUrl}members/lists/with-extras?page=${Page}&pageSize=${PageSize}&ExcludeTransactional=${ExcludeTransactional}`,
	delete_mailing_list: `${gatewayUrl}members/lists/{mailingListId}`,
	delete_many_lists: (MailingListsIds: string) => `${gatewayUrl}members/lists/many?${MailingListsIds}`,
	set_label: `${gatewayUrl}members/lists/{mailingListId}/labels`,
	delete_labels: `${gatewayUrl}members/lists/{mailingListId}/labels?Name={name}`,
	get_labels: `${gatewayUrl}members/lists/{mailingListId}/labels/all`,
	get_all_labels: `${gatewayUrl}members/lists/labels/all`,
	set_many_labels: `${gatewayUrl}members/lists/labels/many`,
	delete_segment: (segmentId: string, mailingListId: string) =>
		`${gatewayUrl}members/segmentation/segments/delete/${segmentId}?mailingListId=${mailingListId}`,
	delete_many_segments: (SegmentsIds: string) => `${gatewayUrl}members/segmentation/segments/many?${SegmentsIds}`,
	get_old_click_map: (campaignId: string, apiKey: string) =>
		`${oldApis.support_api}campaigns/${campaignId}/stats/click_map.json?format=json&mode=view&apikey=${apiKey}`,
	get_members: (mailingListId: string, page: number, pageSize: number) =>
		`${gatewayUrl}members/segmentation/fetch/expression/noprefetch?mailingListId=${mailingListId}&page=${page}&pageSize=${pageSize}&timezone=Local`,
	get_segments: `${gatewayUrl}members/segmentation/segments/search`,
	set_segments_labels: `${gatewayUrl}members/segmentation/segments/many/labels`,
	get_all_segments_labels: `${gatewayUrl}members/segmentation/segments/labels`,
	remove_member: `${gatewayUrl}members/remove`,
	remove_many_members: `${gatewayUrl}members/remove-many`,
	delete_member: `${gatewayUrl}members/delete`,
	delete_many_members: `${gatewayUrl}members/delete-many`,
	subscribe_member: `${gatewayUrl}members/subscribe`,
	subscribe_many: `${gatewayUrl}members/subscribe-many`,
	get_member: (id: string) => `${gatewayUrl}members/${id}`,
	update_member: `${gatewayUrl}members/update`,
	get_list_settings: (id: string) => `${gatewayUrl}list-settings/${id}`,
	remove_list_setting: (id: string, queryParams: string) => `${gatewayUrl}list-settings/remove/${id}?${queryParams}`,
	update_list_settings: `${gatewayUrl}list-settings/`,
	set_custom_field_definition: (mailingListId: string) => `${gatewayUrl}members/lists/${mailingListId}/customfields`,
	delete_custom_fields_definitions: (mailingListId: string, cfIds: string) =>
		`${gatewayUrl}members/lists/${mailingListId}/customfields/many?${cfIds}`,
	merge_members: `${gatewayUrl}members/merge`,
	get_all_members_tags: (mailingListId: string) => `${gatewayUrl}members/segmentation/options/tags/${mailingListId}`,
	subscription_process: (mailingListId: string) => `${gatewayUrl}members/lists/${mailingListId}/subscription-process`,
	double_optin_setting: `${gatewayUrl}list-settings/double-optin`,
	//merge_customfields: `${gatewayUrl}members/lists/merge/customfields`,
	copy_customfields: (mailingListId: string) => `${gatewayUrl}members/lists/${mailingListId}/customfields/many`,
	save_mailing_list: `${gatewayUrl}members/lists`,
	save_cf_order: `${gatewayUrl}list-settings/customfield-order`,
	clone_mailinglist: (mailingListId: string) => `${gatewayUrl}members/lists/${mailingListId}/clone`,
	update_many_customfields: `${gatewayUrl}members/update-many-customfields`,
	update_many_status: `${gatewayUrl}members/statuses`,
	get_suppression_list: `${gatewayUrl}members/lists/suppression`,
	name_fallback_value: `${gatewayUrl}members/lists/namefallback`,
	set_preferences_settings: (mailingListId: string) => `${gatewayUrl}members/lists/${mailingListId}/preferences`,
	add_many_members_tags: `${gatewayUrl}members/add-tags`,
	delete_many_members_tags: `${gatewayUrl}members/delete-tags`,
	search_members: (query: string) => `${gatewayUrl}members/segmentation/fetch${query}&timezone=Local`,
	has_unique_members: `${gatewayUrl}members/uniques/status`,
};

const members_operations_service = {
	get_plugins: `${gatewayUrl}members/plugins?status=Accepted`,
	filterspec: (id: string) => `${gatewayUrl}members/plugins/${id}/filterspec`,
	preview: (id: string) => `${gatewayUrl}members/plugins/${id}/preview`,
	authspec: (id: string, redirectUri: string) => `${gatewayUrl}members/plugins/${id}/authspec?redirectUri=${redirectUri}`,
	pluginauths: (id: string) => `${gatewayUrl}members/plugins/pluginauths/${id}`,
	import: `${gatewayUrl}members/operations`,
	operation_reports: (id: string, pagesize: number) =>
		`${gatewayUrl}members/operations/all/reports?mailingListID=${id}&pagesize=${pagesize}`,
	plugin_ids: {
		copy: 'c50aaaeb-10a5-44c3-b65c-935d3257a943',
	},
};

const segments_service = {
	base_url: `${gatewayUrl}members/segmentation`,
	get_segments: `${gatewayUrl}members/segmentation/segments`,
	get_segments_members_count: `${gatewayUrl}members/segmentation/count/{segmentIds}`,
	get_segment_count: (mailingListId: string) => `${gatewayUrl}members/segmentation/count?mailingLIstId=${mailingListId}`,
	get_segments_fields: (params: string) => `${gatewayUrl}members/segmentation/fields${params}`,
	get_segments_fields_all: `${gatewayUrl}members/segmentation/fields/all`,
	get_segments_suggestions: (field: string, queryParams?: string) => `${gatewayUrl}members/segmentation/options/${field}${queryParams}`,
	get_custom_field_suggestions: (field: string, queryParams?: string) =>
		`${gatewayUrl}members/segmentation/options/CustomField?customFieldId=${field}${queryParams}`,
	create_segment: (mailingListId: string) => `${gatewayUrl}members/segmentation/segments/create?mailingListId=${mailingListId}`,
	get_description: `${gatewayUrl}members/segmentation/segments/description`,
	get_segment: (sid: string, mailingListId: string) => `${gatewayUrl}members/segmentation/segments/${sid}?mailingListId=${mailingListId}`,
	update_segment: (sid: string, mailingListId: string) =>
		`${gatewayUrl}members/segmentation/segments/update/${sid}?mailingListId=${mailingListId}`,
	export_segment: `${gatewayUrl}members/segmentation/segments/export/start`,
	export_cancel: `${gatewayUrl}members/segmentation/segments/export/cancel`,
	fetch_members: (mailingListId: string, page: number, pageSize: number) =>
		`${gatewayUrl}members/segmentation/fetch?timezone=Local&mailingListId=${mailingListId}&page=${page}&pageSize=${pageSize}`,
	copy_segment: (segmentId: string, params: string) => `${gatewayUrl}members/segmentation/segments/copy/${segmentId}?${params}`,
	copy_segments: (params: string) => `${gatewayUrl}members/segmentation/segments/copy/many?${params}`,
};

const auxiliary_service = {
	base_url: `${gatewayUrl}campaigns/auxiliary`,
	send_test: `${gatewayUrl}campaigns/auxiliary/send-test`,
	create_spam_request: `${gatewayUrl}campaigns/auxiliary/spam-checking`,
	retrieve_spam_request: (spamRequestId: string) => `${gatewayUrl}campaigns/auxiliary/spam-checking/${spamRequestId}`,
	get_preview: (newsletterID: string) => `${gatewayUrl}campaigns/auxiliary/templating/${newsletterID}/preview`,
	open_rate_suggestions: `${gatewayUrl}campaigns/auxiliary/predict/open-rate/basic`,
	check_can_predict_open_rate: `${gatewayUrl}campaigns/auxiliary/predict/open-rate/can-predict-basic`,
	get_image_preview: (campaignId: string, ab: string) => `${gatewayUrl}campaigns/auxiliary/campaign/${campaignId}/image/${ab}`,
};

const editor = {
	editor_moosend_url: (location: Location, hasContent?: boolean) =>
		`${location.origin}/design/${
			!hasContent ? `template-library?` : `?hasBlueprints=true&`
		}newsletterID={campaignID}&redirectUrl={redirectUrl}&secondaryRedirectUrl={secondaryRedirectUrl}`,
	editor_non_moosend_url: (location: Location, hasContent?: boolean) =>
		`${location.origin}/design/${
			!hasContent ? `template-library?` : `?hasBlueprints=true&`
		}newsletterID={campaignID}&redirectUrl={redirectUrl}&secondaryRedirectUrl={secondaryRedirectUrl}`,
	editor_template_library: (redirectUrl: string, type: string, location: Location) => {
		const secondaryRedirectUrl = encodeURIComponent(redirectUrl);
		const editorType = encodeURIComponent(type);
		return `${location.origin}/design/template-library?secondaryRedirectUrl=${secondaryRedirectUrl}&editorType=${editorType}`;
	},
	editor_generic_moosend_url: (location: Location, hasContent?: boolean) =>
		`${'${location.origin}'}/design/?genericId={genericId}&redirectUrl={redirectUrl}&secondaryRedirectUrl={secondaryRedirectUrl}`,
};

const designer = {
	moosend_url: (
		location: Location,
		type: string,
		entityId: string,
		redirectUrl: string,
		secondaryRedirectUrl: string,
		hasBlueprints?: boolean
	) =>
		`${location.origin}/design/${
			!hasBlueprints ? `template-library?` : `?hasBlueprints=true&`
		}editorType=${type}&entityId=${entityId}&redirectUrl=${redirectUrl}&secondaryRedirectUrl=${secondaryRedirectUrl}`,
	non_moosend_url: (
		location: Location,
		type: string,
		entityId: string,
		redirectUrl: string,
		secondaryRedirectUrl: string,
		hasBlueprints?: boolean
	) =>
		`${location.origin}/design/${
			!hasBlueprints ? `template-library?` : `?hasBlueprints=true&`
		}editorType=${type}&entityId=${entityId}&redirectUrl=${redirectUrl}&secondaryRedirectUrl=${secondaryRedirectUrl}`,
	designer_template_library: (redirectUrl: string, type: string, location: Location) => {
		const secondaryRedirectUrl = encodeURIComponent(redirectUrl);
		const editorType = encodeURIComponent(type);
		return `${location.origin}/design/template-library?secondaryRedirectUrl=${secondaryRedirectUrl}&editorType=${editorType}`;
	},
};

const oldeditor = {
	editor_moosend_url: `https://frontend-editor.services.moostaging.com/?apiKey={apiKey}&newsletterID={campaignID}&redirectUrl={redirectUrl}&secondaryRedirectUrl={secondaryRedirectUrl}`,
	editor_non_moosend_url: `https://frontend-editor.services.moostaging.com/?apiKey={apiKey}&newsletterID={campaignID}&redirectUrl={redirectUrl}&secondaryRedirectUrl={secondaryRedirectUrl}`,
	editor_template_library: (redirectUrl: string, type: string) =>
		`https://frontend-editor.services.moostaging.com/template-library?apiKey={apiKey}&secondaryRedirectUrl=${encodeURIComponent(
			redirectUrl
		)}&editorType=${encodeURIComponent(type)}`,
};

const olddesigner = {
	moosend_url: (
		type: string,
		entityId: string,
		apiKey: string,
		redirectUrl: string,
		secondaryRedirectUrl: string,
		hasBlueprints?: boolean
	) =>
		`https://frontend-designer.services.moostaging.com/${
			!hasBlueprints ? `template-library?` : `?hasBlueprints=true&`
		}editorType=${type}&entityId=${entityId}&apiKey=${apiKey}&redirectUrl=${redirectUrl}&secondaryRedirectUrl=${secondaryRedirectUrl}`,
	non_moosend_url: (
		type: string,
		entityId: string,
		apiKey: string,
		redirectUrl: string,
		secondaryRedirectUrl: string,
		hasBlueprints?: boolean
	) =>
		`https://frontend-designer.services.moostaging.com/${
			!hasBlueprints ? `template-library?` : `?hasBlueprints=true&`
		}editorType=${type}&entityId=${entityId}&apiKey=${apiKey}&redirectUrl=${redirectUrl}&secondaryRedirectUrl=${secondaryRedirectUrl}`,
	designer_template_library: (redirectUrl: string, type: string, apiKey: string, location: Location) => {
		const secondaryRedirectUrl = encodeURIComponent(redirectUrl);
		const editorType = encodeURIComponent(type);
		return `https://frontend-designer.services.moostaging.com/template-library?secondaryRedirectUrl=${secondaryRedirectUrl}&editorType=${editorType}&apiKey=${apiKey}`;
	},
};

const blob_service = {
	blob_url_upload: `${gatewayUrl}blobuploads/new/url?Storage=S3`,
	blob_file_upload: `${gatewayUrl}blobuploads/new/file?Storage=S3`,
	base_url: 'https://upload.staging.m-operations.com',
	url_upload: `${gatewayUrl}blobuploads/new/url?Storage=S3`,
	file_upload: `${gatewayUrl}blobuploads/new/file`,
	import_file_upload: `${gatewayUrl}blobuploads/new/file`,
	old_file_upload: `${oldApis.support_api}campaigns/content/loadfile.json`,
	old_url_upload: `${oldApis.support_api}campaigns/content/loadurl.json`,
};

const analyticsSettings = {
	localEnabled: false, // when developing locally, does not work when features are deployed since analytics instance will be inherited from old plat
	token: '3GYPGbueq5Mp2Vx58PfMs2LG18IlaPvk', // when developing locally, does not work when features are deployed since analytics instance will be inherited from old plat
};

const e2e_tests = {
	app_url: () => 'http://e2e.moostaging.com/#',
	domain: 'e2e',
	email: 'dev+e2e@moosend.com',
	password: '123123123',
	auth_url: (domain: string, username: string, password: string) =>
		'https://authentication-staging.m-operations.com/api/user/authenticate.json?domain=' +
		domain +
		'&UsernameOrEmail=' +
		username +
		'&Password=' +
		password +
		'&format=json',
};

const metadata_service = {
	create_metadata: `${gatewayUrl}md`,
	get_all_metadata_for_user: (category: string) => `${gatewayUrl}md?Category=${category}`,
	get_all_metadata_for_user_with_params: (pagesize: string, page: string, category: string) =>
		`${gatewayUrl}md/pagesize/${pagesize}/page/${page}?Category=${category}`,
	get_metadata: (metadataVersionId: string, category: string) => `${gatewayUrl}md/{key}/${metadataVersionId}?Category=${category}`,
	get_all_metadata_versions: (key: string, pagesize: string, page: string, category: string) =>
		`${gatewayUrl}md/${key}/pagesize/${pagesize}/page/${page}?Category=${category}`,
	create_metadata_version: (key: string) => `${gatewayUrl}md/${key}`,
	delete_metadata: (key: string, params: string) => `${gatewayUrl}md/${key}${params}`,
	get_latest_metadata: (key: string, category: string, noGateway?: boolean) =>
		`${noGateway ? '/' : gatewayUrl}md/${key}/latest?Category=${category}`,
	version: `${gatewayUrl}version`,
};

const metadata_service_old = {
	create_metadata: `${gatewayUrl}metadata`,
	get_all_metadata_for_user: (category: string) => `${gatewayUrl}metadata?Category=${category}`,
	get_all_metadata_for_user_with_params: (pagesize: string, page: string, category: string) =>
		`${gatewayUrl}metadata/pagesize/${pagesize}/page/${page}?Category=${category}`,
	get_metadata: (metadataVersionId: string, category: string) => `${gatewayUrl}metadata/{key}/${metadataVersionId}?Category=${category}`,
	get_all_metadata_versions: (key: string, pagesize: string, page: string, category: string) =>
		`${gatewayUrl}metadata/${key}/pagesize/${pagesize}/page/${page}?Category=${category}`,
	create_metadata_version: (key: string) => `${gatewayUrl}metadata/${key}`,
	delete_metadata: (key: string, params: string) => `${gatewayUrl}metadata/${key}${params}`,
	get_latest_metadata: (key: string, category: string, noGateway?: boolean) =>
		`${noGateway ? '/' : gatewayUrl}metadata/${key}/latest?Category=${category}`,
	version: `${gatewayUrl}version`,
};

// export const getApiKey = (): string|undefined => {

//     const user = localStorage.getItem('moo_user');
//     const apiKey = user && JSON.parse(user).ApiKey;

//     return apiKey;
// };

// const newGatewayUrl = getApiKey() !== 'b61d6cdd-c7f1-470f-9b7a-37b69bb93d1c' ? gatewayUrl : 'https://gw.services.moostaging.com/';
// const ks = ['b61d6cdd-c7f1-470f-9b7a-37b69bb93d1c'];
// const k = getApiKey();
// const newGatewayUrl = k && ks.includes(k) ? 'https://gw.services.moostaging.com/' : 'https://gateway.services.moostaging.com/';

const shapeshift_service = {
	base_url: (noGateway?: boolean) => `${noGateway ? '/' : gatewayUrl}analytics/shapeshift`,
	get_report: (queryId: string, noGateway?: boolean) => `${noGateway ? '/' : gatewayUrl}analytics/shapeshift/query/template/${queryId}`,
	get_exports_remaining: `${gatewayUrl}analytics/shapeshift/metadata/exports-remaining`,
	standalone_report_domain: 'https://reports.moostaging.com',
};

const shapeshift_service_old = {
	get_report: (queryId: string, noGateway?: boolean) => `${noGateway ? '/' : gatewayUrl}analytics/shapeshift/query/template/${queryId}`,
	get_exports_remaining: `${gatewayUrl}analytics/shapeshift/metadata/exports-remaining`,
	standalone_report_domain: 'https://reports.moostaging.com',
};

const entitiesService = {
	base_url: `${gatewayUrl}websites/entities`,
	getAllExtras: (pagination: number) => `${gatewayUrl}websites/entities/extras?Page=${pagination}`,
	getTotalsByType: `${gatewayUrl}websites/entities/count`,
	getAllWithFilters: `${gatewayUrl}websites/entities/filter`,
	getEntity: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/with-extras`,
	saveBlueprint: `${gatewayUrl}websites/entities/blueprints`,
	updateBlueprint: (entityId: string, blueprintId: string) => `${gatewayUrl}websites/entities/${entityId}/blueprints/${blueprintId}`,
	getBlueprints: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/blueprints`,
	createEntity: `${gatewayUrl}websites/entities`,
	duplicateEntity: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/clone`,
	deleteEntity: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}`,
	deleteManyEntities: (entityIds: string) => `${gatewayUrl}websites/entities/many?EntityIds=${entityIds}`,
	setTags: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/tags`,
	setManyTags: `${gatewayUrl}websites/entities/many/tags`,
	getTags: (type: EntityType) => `${gatewayUrl}websites/entities/all/tags?WhereEntityType=${type}`,
	getDomains: `${gatewayUrl}websites/entities/metadata/publish-domains`,
	getPublishPlugins: (entityId: string, entityType: string, type: string) =>
		`${gatewayUrl}websites/entities/metadata/${entityId}/ui-spec/publish/${entityType}/${type}?format=json`,
	getExtraFields: (entityId: string, type: string) =>
		`${gatewayUrl}websites/entities/metadata/${entityId}/criteria-spec/form/${type}?format=json`,
	getSettings: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/settings`,
	setSettings: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/settings`,
	updateEntity: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}`,
	publishEntity: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/publish`,
	publishManyEntities: `${gatewayUrl}websites/entities/many/publish`,
	unpublishEntity: (entityId: string) => `${gatewayUrl}websites/entities/${entityId}/unpublish`,
	unpublishManyEntities: `${gatewayUrl}websites/entities/many/unpublish`,
};

const automationsService = {
	base_url: `${gatewayUrl}automations`,
	getAutomations: (page: number, pageSize: number, params?: string) =>
		`${gatewayUrl}automations/page/${page}/pageSize/${pageSize}${params ? params : ''}`,
	getAutomationsByFilters: (page: number, pageSize: number) => `${gatewayUrl}automations/page/1/pageSize/99/with-filters`,
	pauseAutomation: (automationId: string) => `${gatewayUrl}automations/${automationId}/pause`,
	unpauseAutomation: (automationId: string) => `${gatewayUrl}automations/${automationId}/unpause`,
	triggerAutomation: (automationId: string) => `${gatewayUrl}automations/${automationId}/trigger`,
	triggerAutomationForMany: (automationId: string) => `${gatewayUrl}automations/${automationId}/trigger-many`,
};

const imgix = {
	proxy_domain: 'moosend-proxy.imgix.net',
	url_token: 'DRNbBeuYrQjR5Usu',
};

const pusherConfig = {
	APP_KEY: process.env.PUSHER_APP_KEY || '',
	APP_CLUSTER: 'eu',
};

const supportApi = {
	search: (apiKey: string, term: string) => `${oldApis.support_api}account/search.json?apiKey=${apiKey}&term=${term}`,
};

const logos = {
	favicon: (domain: string) =>
		`https://ec1-user-domain-assets.moostaging.com/redirect/setting/PlatformDomain/Favicon?customDomain=${domain}&defaultRedirect=${encodeURIComponent(
			'https://cdn.moostaging.com/assets/images/icons/logo.png'
		)}`,
	logo: (domain: string) =>
		`https://ec1-user-domain-assets.moostaging.com/redirect/setting/PlatformDomain/PlatformLogo?customDomain=${domain}&defaultRedirect=${encodeURIComponent(
			'https://cdn.moostaging.com/assets/images/icons/logo.png'
		)}`,
	faviconSend: (domain: string) =>
		`https://ec1-user-domain-assets.moostaging.com/redirect/setting/PlatformDomain/Favicon?customDomain=${domain}&defaultRedirect=${encodeURIComponent(
			'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/mark-send'
		)}`,
	logoSend: (domain: string) =>
		`https://ec1-user-domain-assets.moostaging.com/redirect/setting/PlatformDomain/PlatformLogo?customDomain=${domain}&defaultRedirect=${encodeURIComponent(
			'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/mark-send'
		)}`,
};

const contentHub = {
	auth: `${newGatewayUrl}integrations/content-hub/authenticate`,
};

const identity_jwt = {
	instagram_posts: `${gatewayUrl}identity-jwt/instagram/posts`,
	instagram_analytics_top_post: `${gatewayUrl}identity-jwt/instagram/analytics/top-post`,
	campaigntemplate_single_post_template: `${gatewayUrl}identity-jwt/campaigntemplate/single-post-template`,
	campaigntemplate_multi_post_template: `${gatewayUrl}identity-jwt/campaigntemplate/multi-post-template`,
	campaigntemplate_creative_freestyle_template: `${gatewayUrl}identity-jwt/campaigntemplate/creative-freestyle-template`,
	campaigntemplate_refine_template: `${gatewayUrl}identity-jwt/campaigntemplate/refine-template`,
};

const generativeAI = {
	subj_line_url: `${gatewayUrl}ai/generative-ai/v1/subject_line`,
	subj_line_urlFromActions: `${gatewayUrl}ai/generative-ai/v1/actions`,
};

const version = {
	version_check: 'https://frontend-platform-package-version.ui.moostaging.com/version.txt',
};

const serviceNowChat = {
	url: (email: string | undefined) =>
		`https://support.moostaging.com/sn_va_web_client_app_embed.do?sysparm_branding_key=moosend_branding&sysparm_email=${email ?? ''}`,
};

const supportCTCTChat = {
	url: 'https://support-ctct-test.moostaging.com/',
};

export default {
	version,
	identity_jwt,
	generativeAI,
	contentHub,
	logos,
	clients,
	supportApi,
	analyticsSettings,
	auxiliary_service,
	automationsService,
	campaign_management_service,
	designer,
	digests_service,
	user_management_service,
	billing_service: billingService,
	entities_service: entitiesService,
	account_service: accountService,
	members_management_service,
	segments_service,
	editor,
	blob_service,
	e2e_tests,
	metadata_service,
	metadata_service_old,
	shapeshift_service,
	shapeshift_service_old,
	imgix,
	oldeditor,
	olddesigner,
	members_operations_service,
	pusherConfig,
	gatewayUrl,
	newGatewayUrl,
	serviceNowChat,
	auth,
	supportCTCTChat,
};
